/*eslint-disable */
const { host } = window.location;
const protocol = (window.location.protocol === 'https:' ? 'https://' : 'http://');
let feedbackHost = `${protocol}aiexchange.test.classba.cn`;

switch (host) {
  case 'mphys.171xue.com':
  case 'mphys.classba.cn':
    feedbackHost = `${protocol}aiexchange.classba.cn`;
    break;
  default:
    break;
}

export { feedbackHost };
